

'use strict';

angular.module('pulianiBookStoreApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('cancellationReturn', {
        url: '/cancellationReturn',
        templateUrl: 'app/cancellation_return/cancellation_return.html',
        controller: 'CancellationReturnCtrl'
      });
  });
